function dutyWishFormData() {
	var aSelectedDepartmentIds = getLocalStorage('myCapitechDutyWishFilter').departmentIds;
	var aSelectedDutyTypeIds = getLocalStorage('myCapitechDutyWishFilter').dutyTypeIds;
	var aDays = [];
	var modelData = {};

	for (var i = 0; i < 7; i++) {
		var tmpObj = {};
		tmpObj.dayNumber = i + 1;
		tmpObj.bChecked = true;
		tmpObj.dayName = moment(new Date()).startOf('week').isoWeekday(1).add(i, 'd').format('dddd');
		aDays.push(tmpObj)
	}
	modelData.days = aDays;

	modelData.dutyWishFilterDepartments = $.grep(getLocalStorage('myCapitechDutyWishFilterValues').departments, function (obj, i) {
		if (isInArray(obj.id, aSelectedDepartmentIds) === false) {
			return false; // remove the element in the array
		}
		obj.bChecked = true;
		obj.bVisible = true;
		return true; // keep the element in the array
	});

	modelData.dutyWishFilterDutyTypes = $.grep(getLocalStorage('myCapitechDutyWishFilterValues').dutyTypes, function (obj, i) {
		if (isInArray(obj.id, aSelectedDutyTypeIds) === false) {
			return false; // remove the element in the array
		}
		obj.bChecked = true;
		obj.bVisible = true;
		return true; // keep the element in the array
	});
	
	return modelData;
}